import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function WarningIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 -1 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.96198 0.534251L15.8704 12.5158C16.2576 13.1878 15.7308 14 14.9084 14H1.0927C0.269231 14 -0.257569 13.1878 0.129624 12.5158L7.03692 0.534251C7.44811 -0.178084 8.55188 -0.178084 8.96198 0.534251ZM8 12C7.4 12 7 11.6 7 11C7 10.4 7.4 10 8 10C8.6 10 9 10.4 9 11C9 11.6 8.6 12 8 12ZM9 9H7V4H9V9Z"
        />
      </svg>
    </Icon>
  );
}
